import { attachAudioPresenterSources } from '@shoflo/polymer';
import { logProgramChange } from '@shoflo/studio-redux/utils';

import { BROADCAST_DELETE_SOURCES } from '@shoflo/studio-redux/actions/types';

import { setProgram } from 'actions/program';

import { withCurrentParams } from 'utils/actionUtils';
import { sceneBuilder } from '@studio/program';

/**
 * It will delete unassigned presenter sources,
 * check whether they exist in the program,
 * rebuild the scene without the unassigned presenter sources.
 * @param {Array} ids Source ids to be deleted.
 * @param {Function} setProgram Function to set the current program
 */
function deleteSources(ids) {
  return withCurrentParams(
    (dispatch, { teamId, eventId, broadcastId }, getState) => {
      const {
        banners,
        sceneLayout,
        sceneLayers,
        attendeeMuteStatus,
        program: { layers },
        brandingSettings,
      } = getState();

      const sources = layers?.map(function ({ source }) {
        return source;
      });

      const isSourceInStage = sources?.some(function (source) {
        return ids.includes(source._id);
      });

      const action = {
        type: BROADCAST_DELETE_SOURCES,
        request: async (apiClient) => {
          await apiClient.broadcast.deleteSources(
            teamId,
            eventId,
            broadcastId,
            {
              ids,
              action: 'delete',
            }
          );

          return ids;
        },
      };

      dispatch(action);
      // remove sources we are deleting from program
      // Reconstruct scene only when sources to be deleted are in the program
      if (isSourceInStage) {
        const sourcesToKeepInProgram = sources?.filter(function (source) {
          return !ids.includes(source._id);
        });

        const withAudioPresenterSources = attachAudioPresenterSources(
          sourcesToKeepInProgram,
          attendeeMuteStatus
        );

        const combinedLayers = [...sceneLayers, ...banners];

        const scene = sceneBuilder(
          sceneLayout,
          withAudioPresenterSources,
          combinedLayers,
          {},
          {},
          brandingSettings?.fonts
        );

        dispatch(setProgram(scene));
        logProgramChange(getState, 'deleteSources action');
      }
    }
  );
}

export default deleteSources;
